import { makeAddValueToLinkState } from "seneca-common/utils/routing";

import { Options as SubscriptionLinkOptions } from "features/subscriptions/features/what-is-premium";

import { linkToTeacherDashboard } from "../../links";

export function linkToTeacherWhatIsPremiumPage() {
  return `${linkToTeacherDashboard()}/what-is-premium`;
}

export function makeLinkToTeacherWhatIsPremium(
  options: SubscriptionLinkOptions
) {
  return makeAddValueToLinkState(options)(linkToTeacherWhatIsPremiumPage());
}
